export enum ClientRelation {
    HOLDER = 'Holder',
    AUTHORIZED = 'Authorised',
}
